/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {resolveReference} from '../api'

export const useMutationResolveReference = createReactQueryMutationHook('resolveReference', resolveReference)
